import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";

declare var ko: any;

export class accountingReportByRolegroup_template extends vnTemplate{

    protected validationsList: validationsList_template;
    protected filterPaymentsDate: filterDropdown_template;
    protected classificationFilter: filterDropdown_template
    protected companyFilter: filterDropdown_template
    protected currencyFilter: filterDropdown_template

    protected getTemplateHtml(): string{

        return `

           <div class="sub-header">
                <div class="w-justify">
                    <div class="w-left">
                        <div><label for="idPayment" class="form-label form-label-box">Payment Date</label>` + this.filterPaymentsDate.getHtmlBuild() + `</div>
                        <div><label class="form-label form-label-box">Classification</label>${this.classificationFilter.getHtmlBuild()}</div>
                        <div><label class="form-label form-label-box">Company</label>${this.companyFilter.getHtmlBuild()}</div>
                        <div><label class="form-label form-label-box">Currency</label>${this.currencyFilter.getHtmlBuild()}</div>
                    </div>
                </div>
           </div>     
           
           <div class="sub-header" style="border: 0;" id="report-buttons-section">     
                <div class="w-justify">
                    <div class="w-left">
                        <button class="btn icon i-export" type="button" data-bind=" event: { click: onClickExportRoleGroupData.bind($data,'roleGroupReport') }">Export Accounting Report by Role Group</button>
                        <button class="btn icon i-export" type="button" data-bind=" event: { click: onClickExportRoleGroupData.bind($data,'accrualReport') }">Export Accrual Report by Role Group</button>
                        <button class="btn icon i-export" type="button" data-bind=" event: { click: onClickExportBalanceTransfer }">Export Balance Transfer </button>
                    </div>
                </div>
            </div>
            
            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                   <div id="selected-accounts"></div>
                </div>
            </div>
            
            ` + this.validationsList.getHtmlBuild() + ` 
            
           
            `;
    }

    protected initPartial(): void {
        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this.caller);
        this.filterPaymentsDate = new filterDropdown_template("filterPaymentsDate", this.getTemplateViewModel(), this.caller);
        this.filterPaymentsDate.setLabel("Payment")
        this.classificationFilter = new filterDropdown_template('classificationFilter', this.getTemplateViewModel(), this.caller);
        this.classificationFilter.setLabel("Classification");

        this.companyFilter = new filterDropdown_template('companyFilter', this.getTemplateViewModel(), this.caller);
        this.companyFilter.setLabel("Company");
        this.currencyFilter = new filterDropdown_template('currencyFilter', this.getTemplateViewModel(), this.caller);
        this.currencyFilter.setLabel("Currency");
    }

    protected getTemplateName(): string{
        return "accountingReportByRolegroup-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): Array<string>{
        return ["w-content"];
    }

    protected buildViewModel(): any{

        // define the viewmodel data/ functions
        let self = this;
        return  {
            payments: ko.observableArray([]),
            idPayment: ko.observable(null),
            onChangeFilterAction: (data, event) => { self.onChangeFilterAction(data); },
            onClickExportRoleGroupData: (report, data, event) => { self.onClickExportRoleGroupData(report); },
            onClickExportBonusAccrualData: (report, data, event)  => { self.onClickExportBonusAccrualData(report); },
            onClickExportBalanceTransfer: (data, event)  => { self.onClickExportBalanceTransfer(data); }
        };
    }

    public getViewModelForRequest() {

        return {
            filters: {
                idPayment: this.getTemplateViewModel().filterPaymentsDate.selectedOption(),
                idClassification: this.getTemplateViewModel().classificationFilter.selectedOption(),
                idCompany: this.getTemplateViewModel().companyFilter.selectedOption(),
                idCurrency: this.getTemplateViewModel().currencyFilter.selectedOption(),
            }
        }
    }

    private getAccountIds(): number[] {

        let idClassification = this.getTemplateViewModel().classificationFilter.selectedOption();
        let idAccounts = [1, 2, 3];
        if (idClassification == 2) {
            idAccounts = [4];
        }

        return idAccounts;
    }

    public onChangeFilterAction(data) {
        this.caller.filterSimpleOnChange();
    }

    public onClickExportRoleGroupData(report){
        this.caller.getDataForExport(report);
    }

    public onClickExportBonusAccrualData(report){
        this.caller.getDataForExport(report);
    }

    public setPaymentDateOptions(options) {

        let paymentDates = [];
        for (let item of options)
        {
            item.name = item.datePaid;
            paymentDates.push(item)
        }

        let temp = this.onChangeFilterAction;
        this.onChangeFilterAction = function(){};
        this.filterPaymentsDate.setOptions(paymentDates);
        this.onChangeFilterAction = temp;
    }

    public setIdPayment(idPayment){
        this.getTemplateViewModel().idPayment(idPayment);
    }

    public setBrandCosts(brandCosts){
        this.getTemplateViewModel().brandCosts(brandCosts);
    }

    public setTotalCostCAD(totalCostCAD){
        this.getTemplateViewModel().totalCostCAD(totalCostCAD);
    }

    public setTotalCostUSD(totalCostUSD){
        this.getTemplateViewModel().totalCostUSD(totalCostUSD);
    }

    public setUserTaxes(userTaxes){
        this.getTemplateViewModel().userTaxes(userTaxes);
    }

    public setBrand(brand){
        this.getTemplateViewModel().brand(brand);
    }

    public setClassifications(classifications): void {
        this.classificationFilter.setOptions(classifications);
    }
    public setCompanies(companies){

        this.companyFilter.setOptions(companies);
    }

    public setCurrencies(currencies){

        this.currencyFilter.setOptions(currencies);
    }

    public onClickExportBalanceTransfer(data){
        this.caller.exportBalanceTransferToCSV();
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/accountingReportByRolegroup_template.ts